<template>
  <Bar />
  <div class="background">
    <div class="information">
      <p v-if="email_verified !== null">Email verified: {{ email_verified }}</p><br>
      <p v-if="discord_verified !== null">Discord verified: {{ discord_verified }}</p><br>
    </div>
  </div>
</template>

<script>
import Bar from '@/components/Bar.vue';
import { updateStoreData } from '@/composables/store';
import router from '@/router';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  components: { Bar },
  setup() {
    const store = useStore();
    const email_verified = computed(() => store.state.email_verified);
    const discord_verified = computed(() => store.state.discord_verified);

    onMounted(async () => {
      const success = await updateStoreData()
      if (success === false) {
        router.push("/login")
      }
    });

    return {
      email_verified,
      discord_verified,
    };
  },
};
</script>
<style>
.information {
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  box-sizing: border-box;
}

.information p {
  margin: 10px 0;
}
</style>
